import type { MEETING_SCENE_SOURCE } from '@src/page/toc/common/meeting-room-manager/message_const';
import type { IUiDataService } from '@src/slide/domain/ui-model/service/ui-data-service.interface';
import type { IMediaManager } from '../../media-manager/media-manager.interface';
import { PlayerType } from '../../note-view-media-sync-manager/core/note-view-media-sync-manager.interface';
import type { ILiveManager } from '@src/slide/application/service/live-manager/core/interface';
import { IDynamicService } from '@src/slide/infrastructure/module/independent/dynamic-loader/dynamic-service';

export enum MediaCmd {
    /** 播放 */
    PLAY = 'play',
    /** 暂停 */
    PAUSE = 'pause',
    /** 快进/后退 */
    SEEK = 'seek',
    /** 倍速 */
    SPEED = 'speed',
}

export interface IMediaSyncInfo {
    /** mediaId */
    mediaId: string;
    /** media 命令 */
    cmd: MediaCmd,
    /** 播放时间 */
    playtime: number;
    /** 播放速度 */
    speed?: number;
}

export interface IServices {
    mediaManager: IMediaManager;
    uiDataService: IUiDataService;
    liveManager: IDynamicService<ILiveManager>;
}

/** 远程演示视频同步接口  */
export interface IRemoteMediaSyncManager {
    init: (sceneSource: MEETING_SCENE_SOURCE) => void;
    reset: () => void
    setServiceDelegates: (services: IServices) => void;
    /** 播放器层 绑定音视频事件 */
    attachMediaEventInPlayer: (mediaInstance: any, mediaId: string, playType: PlayerType) => (() => void)[];
    /** 房间层 绑定接收播放器事件 */
    attachRecvPlayerEventInRoom: () => (() => void);
    /** LiveManager层 监听音视频变化 */
    attachLiveManagerMediaEvent: () => (() => void);
    /** 播放器层 绑定接收音视频变化 */
    attachRecvMediaChangeInPlayer: () => (() => void);
}

export interface IRemoteMediaSyncManagerInjectable {
    attachMediaEventInPlayer: (playType: PlayerType) => boolean;
}
